/* eslint-disable @typescript-eslint/naming-convention */
export enum mediaSubscriptionAttributeTypes {
    createdBy,
    createdDate,
    modifiedBy,
    modifiedDate
}
